/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Contribute_DescriptionInputs */



/**
* | output |
* | --- |
* | "Submit missing cards, corrections, and images to the catalogue for review." |
*
* @param {Nav_Locked_Contribute_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_contribute_description = /** @type {((inputs?: Nav_Locked_Contribute_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Contribute_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Reiche fehlende Karten, Korrekturen und Bilder für den Katalog zur Prüfung ein.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proposez des cartes manquantes, des corrections et des images pour le catalogue.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("向卡牌库提交缺失的卡牌、勘误和图片以供审核。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("向卡牌目錄提交缺少的卡牌、修正與圖片，等待審核。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("빠진 카드, 오류 수정, 이미지를 카탈로그에 제출해 검토받으세요.")
	return /** @type {LocalizedString} */ ("Submit missing cards, corrections, and images to the catalogue for review.")
});